import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { downGradeOfferModalTexts, paths } from 'src/common/config/TextMessage';
import { downGradeOfferModalSxs } from '../newChangePlan';
import { RootState } from 'src/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import {
  downgradeDeactivateOffers,
  getAddonDetails,
  getSubscriptionDetailsStripe
} from 'src/common/Scraper';
import CommonAlert from 'src/common/CommonAlert';
import {
  setAddonDetails,
  setScanDetails,
} from 'src/redux/counterSlice';
import { setProgressCalculation } from 'src/common/config/FunctionHelper';
import { setStateStripeSubscription } from 'src/redux/userReducer';
import { useNavigate } from 'react-router';
import { setOfferApplied } from 'src/redux/dashboard';
import { useUserDetails } from 'src/hooks/apiHooks/useUserDetails';

export const TooExpensive = ({
  selectedTimeLine = '',
  handCloseModal = () => {},
  handleChangePlanModal = () => {},
  isFromDeactivate = false,
  setIsOfferApplied
}) => {
  const [loading, setLoading] = useState(null);
  const [responseMessage, setResponseMessage]: any = useState(null);
  let userDetails: any =
    useSelector((state: RootState) => state.counter.userDetails) ?? {};
  let stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  let isPremiumUser = useSelector((state: RootState) => state.user.premiumUser);
  const { refetch: refetchUserDetails } = useUserDetails({ enabled: false });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleRedeemOffer = async () => {
    setLoading(true);
    setIsOfferApplied(true);
    const payload = {
      subscriptionId: stripeSubscriptionDetails?.subscription_id,
      selectedDowngradeReason: 'Too Expensive',
      planId: stripeSubscriptionDetails?.plan_name?.id
    };
    const downgradeDeactivateOffersResponse: any =
      await downgradeDeactivateOffers(payload);

    setResponseMessage({
      status: downgradeDeactivateOffersResponse?.status,
      message: downgradeDeactivateOffersResponse?.message
    });
    if (downgradeDeactivateOffersResponse?.status == 'success') {
      const subscriptionDetailsStripe = await getSubscriptionDetailsStripe();
      if (subscriptionDetailsStripe != undefined) {
        dispatch(setStateStripeSubscription(subscriptionDetailsStripe));
      } else {
        dispatch(setStateStripeSubscription({}));
      }
      if (isFromDeactivate) {
        const { data: userDetailsResponse } = await refetchUserDetails();
        if (isPremiumUser) {
          // Fetch additional scan details for premium users
          let addonScan = await getAddonDetails();
          let getProgressScore = setProgressCalculation(
            userDetailsResponse,
            addonScan
          );
          dispatch(setScanDetails(getProgressScore));
          dispatch(setAddonDetails(addonScan));
        }
      }
    }
    setTimeout(() => {
      setLoading(false);
      setIsOfferApplied(false);
      setResponseMessage(null);
      if (downgradeDeactivateOffersResponse?.status == 'success') {
        dispatch(setOfferApplied({ open: true }));
        navigate(paths?.dashboard);
        handCloseModal();
        handleChangePlanModal();
      }
    }, 3000);
  };
  return (
    <>
      {/*<Chip
        label={
          <Typography sx={downGradeOfferModalSxs?.billedMonthlyTextSx}>
            {downGradeOfferModalTexts.billedMonthly}
          </Typography>
        }
        sx={downGradeOfferModalSxs?.recommendedMobileChipStyle}
      />*/}
      <Typography sx={downGradeOfferModalSxs?.offerCardHeadTextSx}>
        {downGradeOfferModalTexts?.tooExpensiveOfferDesc}
      </Typography>
      <Typography sx={downGradeOfferModalSxs?.offerCardDescTextSx}>
        {selectedTimeLine == 'Annually'
          ? downGradeOfferModalTexts?.offForThreeMonths
          : downGradeOfferModalTexts?.offForOneMonth}
      </Typography>
      {responseMessage?.status && (
        <Box className="mt-1">
          <CommonAlert
            severity={responseMessage?.status}
            message={responseMessage?.message}
          />
        </Box>
      )}
      <Button
        variant="contained"
        fullWidth
        sx={downGradeOfferModalSxs?.offerCardBtnSx}
        onClick={handleRedeemOffer}
      >
        {loading ? (
          <CircularProgress color="inherit" size={24} />
        ) : (
          downGradeOfferModalTexts?.redeemOffer
        )}
      </Button>
    </>
  );
};
